/* jshint browser: true */

/* jshint unused: false */

/* global Backbone, templateEngine, arangoHelper, $, window, frontendConfig */
(function () {
  'use strict';

  window.MetricsView = Backbone.View.extend({
    template: templateEngine.createTemplate('metricsView.ejs'),
    infoTemplate: templateEngine.createTemplate('infoView.ejs'),
    el: '#content',
    metricsel: undefined,
    interval: 10000,
    activeView: 'table',
    events: {
      'click #toggleView': "toggleView",
      'click #downloadAs': "downloadAs",
      'click #reloadMetrics': "reloadMetrics"
    },
    initialize: function initialize(options) {
      if (options) {
        this.options = options;

        if (options.endpoint) {
          this.endpoint = options.endpoint;
        }

        if (options.contentDiv) {
          this.metricsel = options.contentDiv;
        }
      }
    },
    downloadAs: function downloadAs() {
      var currentDate = new Date();
      var fileName = "METRICS-".concat(currentDate.toISOString());

      if (this.activeView === 'table') {
        arangoHelper.downloadLocalBlob(JSON.stringify(this.collection.toJSON(), null, 2), 'json', fileName);
      } else {
        arangoHelper.downloadLocalBlob(this.collection.metricsAsText(), 'text', fileName);
      }
    },
    toggleView: function toggleView() {
      if (this.activeView === 'table') {
        $('#toggleView').text('Show Table');
        $('#metricsAsText').show();
        $('#metricsAsTable').hide();
        this.activeView = 'text';
      } else {
        $('#toggleView').text('Show Text');
        $('#metricsAsText').hide();
        $('#metricsAsTable').show();
        this.activeView = 'table';
      }
    },
    breadcrumb: function breadcrumb(name) {
      $('#subNavigationBar .breadcrumb').html('Metrics');
    },
    reloadMetrics: function reloadMetrics() {
      var self = this;
      this.collection.fetch({
        success: function success() {
          arangoHelper.arangoNotification('Metrics', 'Reloaded metrics.');
          self.continueRender();
        }
      });
    },
    render: function render() {
      var self = this;

      if (!frontendConfig.metricsEnabled) {
        var disabled = {
          title: "Metrics",
          message: "Metrics are disabled."
        };

        if (this.metricsel) {
          $(this.metricsel).html(this.infoTemplate.render(disabled));
        } else {
          this.$el.html(this.infoTemplate.render(disabled));
        }
      } else {
        this.collection.fetch({
          success: function success() {
            self.continueRender();
          }
        });
      }
    },
    continueRender: function continueRender() {
      if (this.metricsel) {
        $(this.metricsel).html(this.template.render({
          collection: this.collection,
          activeView: this.activeView
        }));
      } else {
        this.$el.html(this.template.render({
          collection: this.collection,
          activeView: this.activeView
        }));
      }
    }
  });
})();